import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { GoalAddComponent } from './goal-add.component';
import { TranslateModule } from '../../../shared/translate/translate.module';
import { ModalsModule } from '../../../widgets/entry-components/modal/modals.module';


@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, ReactiveFormsModule, TranslateModule, ModalsModule],
  declarations: [GoalAddComponent],
  exports: [GoalAddComponent]
})
export class GoalAddModule { }
